import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../state";

export const getTracker = createAsyncThunk('getTracker', async () => {
    try {
        const response = await axios({
            method: 'get',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/tracker'
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const editTracker = createAsyncThunk('editTracker', async (data: any) => {
    try {
        const response = await axios({
            method: 'put',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/tracker',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const addTracker = createAsyncThunk('addTracker', async (data: any) => {
    try {
        const response = await axios({
            method: 'post',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/tracker',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const deleteTracker = createAsyncThunk('deleteTracker', async (id: string) => {
    try {
        const response = await axios({
            method: 'delete',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/tracker?id=' + id,
        })
        return response
    } catch (error: any) {
        return error.response
    }
})